import * as UpgradeProducts from 'self-service-api/constants/UpgradeProducts';
import { validateProperty } from 'ui-addon-upgrades/_core/common/data/upgradeData/validators/validateProperty';
export const validateUpgradeProduct = upgradeProduct => {
  const upgradeProductValues = Object.values(UpgradeProducts);
  const isValidUpgradeProduct = upgradeProductValues.indexOf(upgradeProduct) !== -1;
  return validateProperty(isValidUpgradeProduct, `expected upgradeProduct to be one of ${upgradeProductValues} but got ${upgradeProduct}`, 'upgradeProduct');
};